import { MainCol, MainContainer, MainRow } from "components/common";
import React from "react";
import { MainSection, SwiperWrapper, Text, Title } from "./elements";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/effect-coverflow/effect-coverflow.min.css";
import { EffectCoverflow, Pagination, Navigation, Autoplay } from "swiper";
import swiperimg1 from "../../../assets/images/swiper1.png";
import swiperimg2 from "../../../assets/images/swiper2.png";
import swiperimg3 from "../../../assets/images/swiper3.png";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Swiper as SwiperCore } from "swiper/types";
import { useRef } from "react";
import { Image } from "react-bootstrap";
import { appstore, playstore } from "assets";
const breakpoints = {
  100: {
    slidesPerView: 1,
  },
  576: {
    slidesPerView: 1,
  },
  768: {
    slidesPerView: 2,
  },
  992: {
    slidesPerView: 2,
  },
  1200: {
    slidesPerView: 3,
  },
  1400: {
    slidesPerView: 3,
  },
};

const OverViewComp = () => {
  const swiperRef = useRef<SwiperCore>();

  return (
    <MainSection id="about">
      <MainContainer>
        <MainRow>
          <MainCol lg={5}>
            <AnimationOnScroll animateIn="animate__fadeInLeft">
              <Title>Enterapp.io Overview</Title>
              <Text>
                The multiple crypto solution app !
                <br className="first-br" />
                <br />
                Non-custodial wallet, cross-chain crypto currency & NFT
                aggregator. Card & PoS payments.
                <br className="first-br" />
                <br />
                As Your Crypto WEB3 Neobank.
              </Text>
              <div className="btns-div">
                <Image src={playstore} />
                <Image src={appstore} />
              </div>
              <p className="info-text">
                enterapp.io will also be available at play store and app store
                after launch.
              </p>
            </AnimationOnScroll>
          </MainCol>
          <MainCol lg={7}>
            <AnimationOnScroll animateIn="animate__fadeInRight">
              <SwiperWrapper>
                <IoIosArrowBack
                  className="swiper-button image-swiper-button-next swiper-icon"
                  onClick={() => swiperRef.current?.slidePrev()}
                />
                <Swiper
                  // activeSlideKey='2'
                  effect={"coverflow"}
                  grabCursor={true}
                  centeredSlides={true}
                  // autoplay={{ delay: 1000, disableOnInteraction: false }}
                  slidesPerView={"auto"}
                  breakpoints={breakpoints}
                  coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    depth: 100,
                    modifier: 2,
                    slideShadows: true,
                  }}
                  onBeforeInit={(swiper) => {
                    swiperRef.current = swiper;
                  }}
                  initialSlide={2}
                  pagination={true}
                  modules={[EffectCoverflow, Pagination, Autoplay]}
                  className="mySwiper"
                >
                  <SwiperSlide>
                    <img src={swiperimg1} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src={swiperimg2} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src={swiperimg1} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src={swiperimg3} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src={swiperimg2} />
                  </SwiperSlide>
                </Swiper>
                <IoIosArrowForward
                  className="swiper-button image-swiper-button-prev swiper-icon"
                  onClick={() => swiperRef.current?.slideNext()}
                />
              </SwiperWrapper>
            </AnimationOnScroll>
          </MainCol>
        </MainRow>
      </MainContainer>
    </MainSection>
  );
};

export default OverViewComp;
